import { object } from 'yup';
import { Timestamp } from 'firebase/firestore';

export const TimestampValidator = () => {
  return object().test({
    name: 'is-timestamp-instance',
    // serverTimestamp will result in Timestamp, but only once it reaches server, so we need to accommodate for that.
    test: (value: any, context) => {
      const isNullable = context.schema.spec.nullable;

      // Prevents test from throwing errors when value can be nullable.
      if (isNullable && value === null) return true;

      return value instanceof Timestamp || value._methodName === 'serverTimestamp';
    },
    message: 'Timestamp is not valid',
  });
};
